export default __webpack_public_path__ + "static/media/logo-card-768w.cfa537e5.png";